import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {LimitDTO} from '../models/LimitDTO';

@Injectable({
  providedIn: 'root'
})
export class LimitService {
  private url = environment.baseUrl + '/limit';

  constructor(private httpClient: HttpClient) {
  }

  getListOfLimits(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<LimitDTO>> {
    return this.httpClient.post<PagedResponseDTO<LimitDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  deleteLimit(limitId: bigint) {
    return this.httpClient.delete<{}>(this.url + '/' + limitId);
  }

  getLimitByLimitId(limitId: bigint): Observable<LimitDTO> {
    return this.httpClient.get<LimitDTO>(`${this.url}/${limitId}`);
  }

  saveLimit(limitDTO: LimitDTO) {
    return this.httpClient.post<LimitDTO>(`${this.url}`, limitDTO);
  }
}
